module.exports = __webpack_public_path__ + "static/img/thumb_1.1ce5f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/thumb_1.png
// module id = wyaw
// module chunks = 1